import { FETCH_CONFIGS, CLEAR_CONFIGS } from '@constants/actionTypes';

export function fetchConfigs(payload) {
  return { type: FETCH_CONFIGS, payload };
}

export function clearConfigs(payload) {
  return { type: CLEAR_CONFIGS, payload };
}
